export const filterRecipeCategory = (
  items,
  recipeFilter,
  hasRecipeHighlightFilter,
  limit
) => {
  const matchesCategories = item => {
    const categoryValues = item.recipeCategory.map(category => category.value)
    return recipeFilter.every(filter => categoryValues.includes(filter.value))
  }

  let filteredItems = items

  if (recipeFilter.length > 0) {
    filteredItems = filteredItems.filter(matchesCategories)
  }

  if (hasRecipeHighlightFilter) {
    filteredItems = filteredItems.filter(item => item.recipeHighlight)
  }

  if (filteredItems.length < limit) {
    const remainingSlots = limit - filteredItems.length
    const fallbackItems = [...new Set([...items, ...filteredItems])].slice(
      0,
      remainingSlots
    )
    filteredItems = [...filteredItems, ...fallbackItems]
  }
  return filteredItems
}
